import { base64url } from './base64url'
import {
  createRecoveryCredential,
  signRecoveryCredentials,
} from './recoveryKey'

const { WebAuthn } = require('@dfns/sdk-webauthn')

const devURL =
  process.env.REACT_APP_DEPLOY_ENV === 'prod'
    ? 'https://api.scopex.money'
    : 'https://api.scopex.dev'

const DFNS_WEBAUTHN_RPID =
  process.env.REACT_APP_DEPLOY_ENV === 'prod' ? 'scopex.money' : 'scopex.dev'

const asUrl = (path) => new URL(`${devURL}/dfns` + path)
const get = async (path) => {
  const res = await fetch(asUrl(path), {
    method: 'GET',
    credentials: 'include',
  })
  return res.json()
}

const post = async (path, body) => {
  const token = localStorage.getItem('swToken')
  const res = await fetch(asUrl(path), {
    method: 'POST',
    body: JSON.stringify(body),
    headers: {
      'content-type': 'application/json',
      token: token,
      'x-dfns-app-id':
        process.env.REACT_APP_DEPLOY_ENV === 'prod'
          ? 'ap-4cho1-ea068-2nallpgldeukd6f'
          : 'ap-12un6-urjd2-833o2gs1gm7jbu2g',
    },
    credentials: 'include',
  })
  return res.status !== 204 ? res.json() : undefined
}

export async function login(username) {
  return post('/login', { username })
}

export async function register(username) {
  const challenge = await post('/register/init', { username })

  const webauthn = new WebAuthn({
    rpId: DFNS_WEBAUTHN_RPID,
  })
  const attestation = await webauthn.create(challenge)
  const clientData = {
    type: 'key.create',
    challenge: base64url(challenge.challenge),
    origin: window.location.origin,
    crossOrigin: false,
  }

  return post('/register/complete', {
    signedChallenge: {
      firstFactorCredential: attestation,
    },
    temporaryAuthenticationToken: challenge.temporaryAuthenticationToken,
    clientData,
  })
}

export async function createTransfer(id, walletId) {
  const respo = await post('/transfer/new/init', { id, walletId })
  const {
    requestBody,
    challenge: { challenge, challengeIdentifier, allowCredentials },
  } = respo
  const webauthn = new WebAuthn({
    rpId: DFNS_WEBAUTHN_RPID,
  })

  const assertion = await webauthn.sign(challenge, allowCredentials)
  const res = await post('/transfer/new/complete', {
    requestBody,
    walletId,
    id,
    signedChallenge: { challengeIdentifier, firstFactor: assertion },
  })
}

export async function getUser() {
  return get('/user')
}

export async function listWallets() {
  return get('/wallets/list')
}

export async function getasset(walletId) {
  return post('/wallets/asset', { walletId })
}

export async function deleteUser(userId) {
  const res = post('/user/delete', { userId })
}

export async function listTransfer(walletId) {
  return post('/wallets/transfer', { walletId })
}

export async function createWallet() {
  const {
    requestBody,
    challenge: { challenge, challengeIdentifier, allowCredentials },
  } = await post('/wallets/new/init', { network: 'PolygonMumbai' })

  const webauthn = new WebAuthn({
    rpId: DFNS_WEBAUTHN_RPID,
  })
  const assertion = await webauthn.sign(challenge, allowCredentials)
  const res = await post('/wallets/new/complete', {
    requestBody,
    signedChallenge: { challengeIdentifier, firstFactor: assertion },
  })
}

export async function addNewDevice(name, platform) {
  return await post('/cred/new-request', {
    name: name,
    platform: String(platform).toLowerCase(),
  })
}

export async function addCred(data) {
  const challenge1 = await post('/cred/new')
  if (challenge1.error) {
    return challenge1
  }
  const webauthn = new WebAuthn({
    rpId: DFNS_WEBAUTHN_RPID,
  })
  const attestation = await webauthn.create(challenge1)
  const browserName = window.navigator.userAgent
  const platform = browserName.includes('Android')
    ? 'Android'
    : browserName.includes('iPhone')
    ? 'iOS'
    : 'Desktop'

  return await post('/cred/new/init', {
    name: data.name,
    signedChallenge: { firstFactorCredential: attestation },
    temporaryAuthenticationToken: challenge1.temporaryAuthenticationToken,
    device: `Web Browser(${platform})`,
  })
}

export async function addCredComplete(data) {
  const webauthn = new WebAuthn({
    rpId: DFNS_WEBAUTHN_RPID,
  })
  const { requestBody, challenge } = JSON.parse(data.data)
  const assertion = await webauthn.sign(
    challenge.challenge,
    challenge.allowCredentials
  )
  return await post('/cred/new/complete', {
    requestBody: requestBody,
    signedChallenge: {
      challengeIdentifier: challenge.challengeIdentifier,
      firstFactor: assertion,
    },
  })
}

export async function activateCred(credentialUuid) {
  const {
    requestBody,
    challenge: { challenge, challengeIdentifier, allowCredentials },
  } = await post('/cred/activate/init', { credentialUuid })

  const webauthn = new WebAuthn({
    rpId: DFNS_WEBAUTHN_RPID,
  })
  const assertion = await webauthn.sign(challenge, allowCredentials)

  const res = post('/cred/activate/complete', {
    requestBody,
    signedChallenge: { challengeIdentifier, firstFactor: assertion },
  })
}

export async function DeActivateCred(credentialUuid) {
  const {
    requestBody,
    challenge: { challenge, challengeIdentifier, allowCredentials },
  } = await post('/cred/deactivate/init', { credentialUuid })

  const webauthn = new WebAuthn({
    rpId: DFNS_WEBAUTHN_RPID,
  })
  const assertion = await webauthn.sign(challenge, allowCredentials)

  const res = post('/cred/deactivate/complete', {
    requestBody,
    signedChallenge: { challengeIdentifier, firstFactor: assertion },
  })
}

export async function getcred() {
  let data = await post('/cred/list')
  return data?.challenge?.items ?? []
}

export async function addRecoveryKeys(username) {
  console.log('addRecoveryKeys')
  const challenge1 = await post('/cred/new', { kind: 'recovery' })

  const clientData = {
    type: 'key.create',
    challenge: base64url(challenge1.challenge),
    origin: window.location.origin,
    crossOrigin: false,
  }

  let { challenge, requestBody, recoverySecret, recoveryCredentialId } =
    await post('/add/recovery/init', {
      temporaryAuthenticationToken: challenge1.temporaryAuthenticationToken,
      clientData,
    })

  const webauthn = new WebAuthn({
    rpId: DFNS_WEBAUTHN_RPID,
  })
  const assertion = await webauthn.sign(
    challenge.challenge,
    challenge.allowCredentials
  )

  return await post('/add/recovery/complete', {
    requestBody,
    signedChallenge: {
      firstFactor: assertion,
      challengeIdentifier: challenge.challengeIdentifier,
    },
    recoverySecret: recoverySecret,
    recoveryCredentialId: recoveryCredentialId,
  })
}

export const recoverUser = async (username) => {
  const { challenge } = await post('/recover/init')

  const clientData = {
    type: 'key.create',
    challenge: base64url(challenge.challenge),
    origin: window.location.origin,
    crossOrigin: false,
  }

  const webauthn = new WebAuthn({ rpId: DFNS_WEBAUTHN_RPID })
  const attestation = await webauthn.create(challenge)
  let newCredentials = {
    firstFactorCredential: attestation,
  }

  const res = await post('/recover/complete', {
    tempAuthToken: challenge.temporaryAuthenticationToken,
    newCredentials,
    clientData,
    challenge,
  })
  if (res.error) {
    console.log(res.error)
    const { recoverySecret, recoveryCredentialId, credentials, recovery } = res
    const signedRecoveryPackage = await signRecoveryCredentials(
      username,
      {
        recoveryKey: recoverySecret,
        credentialId: recoveryCredentialId,
        encryptedKey:
          challenge.allowedRecoveryCredentials[0].encryptedRecoveryKey,
      },
      credentials
    )
    console.log('Recovery credentials signed')

    return await post('/recover/complete', {
      tempAuthToken: challenge.temporaryAuthenticationToken,
      newCredentials: credentials,
      signedRecoveryPackage,
      recoverySecret: recovery.secret,
      recoveryCredentialId: recovery.credentialId,
    })
  }
  return res

  // We need to sign the new credentials with the old recovery credential so that the Dfns can verify
  // that we are authorized to recover this account.
}
